<script>
import store from "@/state/store";

export default {
  components: {},
  data() {
    return {
      store: store,
    };
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    classValue: {
      type: String,
      default: "",
    },
    hoverValue: { type: String, default: "" },
    action: {
      default: "",
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    multipleButtonDataInLeftSide: {
      type: Array,
      default: () => [],
    },
    multipleButtonData: {
      type: Array,
      default: () => [],
    },
    isIcon: {
      type: Boolean,
      default: false,
    },
    isButtonDropDown: {
      type: Boolean,
      default: false,
    },
    dropDown: {
      type: String,
      default: "New Booking",
    },
    dropDownItem: {
      type: [Array, Object],
      default: () => [
        { name: "Add", action: "" },
        { name: "Post", action: "" },
      ],
    },
  },
};
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div
        class="page-title-box d-flex align-items-center justify-content-between"
      >
        <h4
          class="mb-0 font-size-18"
          v-if="multipleButtonDataInLeftSide.length == 0"
        >
          {{ title }}
          <router-link
            class="font-size-10 text-decoration-underline"
            to="SyncHistory"
            v-if="
              title === 'Booking' && store.state.auth.hotel.is_pms_connection
            "
          >
            Sync History
          </router-link>
        </h4>
        <div
          class="col-md-8 d-flex justify-content-start"
          v-if="multipleButtonDataInLeftSide.length !== 0"
        >
          <template>
            <div
              class="d-flex"
              v-for="(item, index) in multipleButtonDataInLeftSide"
              :key="item.text"
            >
              <b-button
                :variant="item.variant ?? item.variant_outline"
                :class="index == 0 ? 'me-4 mx-1' : ' mx-1'"
                @click="item.action(item.argument)"
                >{{ item.text }}</b-button
              >
              <h5
                class="mt-2"
                v-if="
                  index !== 0 &&
                  index !== multipleButtonDataInLeftSide.length - 1
                "
              >
                >>>
              </h5>
            </div>
          </template>
        </div>

        <div class="page-title-right" v-if="isButton">
          <span v-if="multipleButtonData.length !== 0">
            <template>
              <b-button
                v-for="(item, index) in multipleButtonData"
                variant="primary"
                class="float-end me-1"
                @click="item.action"
                :key="index"
                >{{ item.text }}</b-button
              >
            </template>
          </span>
          <span v-else>
            <b-button variant="primary" class="float-end" @click="action">{{
              text
            }}</b-button>
          </span>
        </div>
        <span class="page-title-right p-2 me-4 rounded" v-if="isIcon">
          <i
            :class="classValue"
            class="float-end"
            @click="action"
            v-b-popover.hover="hoverValue"
          ></i>
        </span>
        <div class="page-title-right" v-if="isButtonDropDown">
          <b-dropdown
            split
            :text="dropDown"
            variant="outline-primary"
            @click="dropDownItem[0].action"
          >
            <template v-for="(item, index) in dropDownItem">
              <b-dropdown-item
                :key="item.name"
                @click="item.action"
                v-if="index !== 0"
              >
                {{ item.name }}
              </b-dropdown-item>
            </template>
          </b-dropdown>
        </div>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
